export default __webpack_public_path__ + "locales/ko-KR/UploadPanel.json?hash=1dc4ff97c1ac545af792226ed97e839f";